<template>
  <div>
    <div
      v-if="product"
      class="product-showcase cursor-pointer produto-card-custom"
      style="border-radius: 7px !important;"
    >
      <div class="product-image">
        <img
          id="img-produto-card-list"
          @click="openProduct"
          :src="$util.getImageBackend(imagem.base64)"
          :alt="product.nome"
          @error="onImageError"
          class="img-fluid"
        />
        <!-- <div class="discount-badge">-45%</div> -->
      </div>
      <div class="product-details">
        <h6 :title="product.nome" @click="openProduct" class="text-muted product-title">
          {{ product.nome }}
        </h6>
        
        <!-- Linha divisória sempre visível após o título -->
        <div class="divider-line"></div>

        <!-- Ação rápida (Lista de Desejos): não fica sobre a imagem do
             produto - ocupa sua própria linha, entre o título e o preço,
             e só aparece ao passar o mouse sobre o card (ver CSS
             .produto-card-custom:hover .wishlist-toggle-btn). -->
        <div class="card-quick-actions" v-if="!hideWishlist">
          <button
            type="button"
            class="wishlist-toggle-btn"
            :class="{ 'is-active': emDesejos }"
            @click.stop="toggleWishlist(product)"
            v-b-popover.hover.top="emDesejos ? 'Remover da lista de desejos' : 'Adicionar à lista de desejos'"
            :aria-label="emDesejos ? 'Remover da lista de desejos' : 'Adicionar à lista de desejos'"
          >
            <i class="bi" :class="emDesejos ? 'bi-heart-fill' : 'bi-heart'" aria-hidden="true"></i>
          </button>
        </div>
        
        <small class="text-danger status-text" v-if="product.estoque === 0"
          >Indisponível</small
        >
        <div v-if="false" class="row" @click="openProduct">
          <div class="col pr-4 pl-4 pb-2">
            <small class="text-secondary" style="    font-size: 0.99em !important;" :title="product.descricao">
              {{ $util.abreviateText(product.descricao, 35) }}
            </small>
          </div>
        </div>

        <div
          class="text-center price-display"
          @click="openProduct"
          v-if="product.estoque > 0 && exibirPreco"
        >
          <!-- <span class="original-price">R$129</span> -->
          <h4 class="sale-price text-primary">
            <b>R$ {{ $util.formatMoney(product.preco) }}</b>
          </h4>
        </div>
        <div
          class="text-center price-display"
          @click.stop="irParaLogin"
          v-else-if="product.estoque > 0 && !exibirPreco"
        >
          <h4 class="sale-price text-primary" style="font-size: 0.9em;">
            <b><small class="mx3-login-price-link">Faça login para ver o preço</small></b>
          </h4>
        </div>
      </div>
      <div class="btn-container-wrapper" style="position: relative; bottom: 0px; width: 100%; display: flex; justify-content: center;">
        <div class="btn-wrapper-adicionar">
          <b-btn
            v-if="product.estoque > 0"
            block
            id="buy-button-" 
            class="primary text-light btn-adicionar-card"
            variant="primary"
            size="sm"
            style="background: linear-gradient(135deg, var(--mx3-style-primary, #00d9ff) 0, var(--mx3-style-primary-dark, #09c) 100%);"
            v-b-popover.hover.top="'Adicionar ao carrinho'"
            @click="addCart(product)"
          >
            <b class="text-dark btn-text-adicionar" style="display:flex;align-items:center;justify-content:center;gap:4px;">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                class="lucide lucide-shopping-cart-icon lucide-shopping-cart"
              >
                <circle cx="8" cy="21" r="1" />
                <circle cx="19" cy="21" r="1" />
                <path
                  d="M2.05 2.05h2l2.66 12.42a2 2 0 0 0 2 1.58h9.78a2 2 0 0 0 1.95-1.57l1.65-7.43H5.12"
                />
              </svg>
              <span>Adicionar</span>
            </b>
          </b-btn>
          <b-btn
            v-else
            block
            id="notify-button-" 
            class="btn-avise-me-card"
            @click="notificarDisponibilidade"
          >
            <b class="btn-text-adicionar" style="display:flex;align-items:center;justify-content:center;gap:4px;">
              <span>Avise-me quando chegar</span>
            </b>
          </b-btn>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["product", "hideWishlist"],
  data() {
    return {
      // imagem: { base64: "/assets/loading2.gif" },
    };
  },
  computed: {
    clienteLogado(){
      return this.$util.clienteLogado()
    },
    exibirPreco() {
      const configuracoes = this.$store.state.configuracoesSite;
      const ocultarPrecoNaoLogado = configuracoes?.ocultar_preco_nao_logado || false;
      const clienteLogado = this.clienteLogado;
      
      console.log("[DEBUG Product] Configurações:", configuracoes);
      console.log("[DEBUG Product] ocultar_preco_nao_logado:", ocultarPrecoNaoLogado);
      console.log("[DEBUG Product] clienteLogado:", clienteLogado);
      console.log("[DEBUG Product] Deve exibir preço:", !(ocultarPrecoNaoLogado && !clienteLogado));
      
      if (ocultarPrecoNaoLogado && !clienteLogado) {
        return false;
      }
      return true;
    },
    imagem() {
      // Prioriza imagens que já vêm no objeto do produto (nova estrutura)
      if (this.product.imagens && this.product.imagens.length > 0) {
        return { base64: this.product.imagens[0] };
      }
      
      // Fallback para o store global (estrutura antiga)
      if (!this.$store?.state?.imagensDeProduto?.data?.length) return { base64: "/assets/loading2.gif" };
      let imagens = this.$store.state.imagensDeProduto.data.filter(
        (i) => i.produto === this.product.id
      );
      if (!imagens.length) return { base64: "/assets/loading2.gif" };
      let img = imagens[0];
      if (!img.base64) {
        img.base64 = "/assets/loading2.gif";
      }
      return img;
    },
    // Reflete se este produto já está na Lista de Desejos, para pintar o
    // coração preenchido (vermelho) e alternar o título/aria-label do botão.
    emDesejos() {
      const id = String(this.product?.id ?? "");
      return (this.$store.state.desejos || []).some((desejoId) => String(desejoId) === id);
    },
  },
  mounted() {
    this.getImage();
  },
  methods: {
    onImageError(event) {
      event.target.src = "/assets/loading2.gif";
    },
    // Alterna o produto na Lista de Desejos: adiciona se ainda não estiver
    // lá, remove se já estiver (o mesmo botão de coração serve para as duas
    // ações, inclusive dentro da própria página /wishlist). A persistência
    // em localStorage ("itensDesejo") já é feita globalmente pelo watcher
    // de $store.state.desejos em App.vue.
    toggleWishlist(product) {
      // A lista é vinculada à conta; não cria um favorito local de visitante.
      if (!localStorage.getItem("accessToken")) {
        this.$router.push("/login");
        return;
      }
      const id = String(product?.id ?? "");
      const indice = (this.$store.state.desejos || []).findIndex(
        (desejoId) => String(desejoId) === id
      );
      if (indice === -1) {
        this.$store.state.desejos.push(id);
      } else {
        this.$store.state.desejos.splice(indice, 1);
      }
    },
    addCart(product) {
      const jaNoCarrinho = this.$store.state.carrinho.some(
        (id) => String(id) === String(product.id)
      );
      if (jaNoCarrinho) return;
      this.$store.state.carrinho.push(product.id);
      this.$forceUpdate();
    },
    notificarDisponibilidade() {
      const cliente = this.$store.state.cliente || {};
      const nomeCliente = cliente.nome || "";
      const emailCliente = cliente.email || "";
      const mensagemPadrao = `Olá, gostaria de ser notificado quando o produto "${this.product.nome}" estiver disponível em estoque. ${nomeCliente ? 'Meu nome é ' + nomeCliente : ''} ${emailCliente ? 'e meu e-mail é ' + emailCliente : ''}.`;
      
      localStorage.setItem("contato_mensagem_padrao", mensagemPadrao);
      this.$router.push({ name: 'contato' });
    },
    openProduct() {
      localStorage.setItem("productNameMeta", this.product.nome);
      this.$router.push({
        name: 'product',
        params: { id: this.product.id }
      });
    },
    // O aviso "Faça login para ver o preço" leva direto à tela de login,
    // em vez de abrir o produto (que continuaria sem mostrar o preço).
    irParaLogin() {
      if (this.$route && this.$route.path === '/login') return;
      this.$router.push('/login');
    },
    getImage() {},
  },
};
</script>

<style lang="scss">

@media (max-width: 768px) {

  #img-produto-card-list {
    height: 70px !important;
  }
  #products-container-custom {
    width: 100% !important;
    max-width: 100% !important;
  }
  .product-showcase  {
    margin-top: 0 !important;
    h4{
      font-size: 6px !important; /* AJUSTE: Padronizado para 6px */
      padding: 2px 3px !important;
    }
    h6{
      font-size: 6px !important; /* AJUSTE: Padronizado para 6px */
      padding: 2px 3px !important;
    }
  }
  .produto-card-custom{
    padding:0px !important;
    padding-bottom: 0px !important;
  }

  /* CORREÇÃO 2.3: Título do produto com altura ajustada para acomodar textos reduzidos */
  /* AJUSTE: Padronizar para 6px conforme solicitado */
  h6.product-title {
    min-height: 42px !important;
    max-height: 42px !important;
    overflow: hidden !important;
    display: -webkit-box !important;
    -webkit-line-clamp: 6 !important;
    -webkit-box-orient: vertical !important;
    text-overflow: ellipsis !important;
    font-size: 6px !important; /* Padronizado para 6px */
    line-height: 1.2 !important;
    padding: 3px 3px 3px 3px !important;
    margin: 0 !important;
    margin-bottom: 0 !important;
  }
  
  .product-showcase h6.product-title {
    min-height: 42px !important;
    max-height: 42px !important;
    -webkit-line-clamp: 6 !important;
  }

  /* Mobile: espaço ZERO entre título e linha separadora */
  .divider-line {
    margin: 0 3px 0 3px !important;
    width: calc(100% - 6px) !important;
    flex-shrink: 0 !important;
    height: 1px !important;
    background-color: rgba(255, 255, 255, 0.1) !important;
  }

  /* CORREÇÃO 2.3: Padronizar textos de status e preço para 6px com espaçamento simétrico */
  /* Seletores de altíssima especificidade para mobile */
  .produto-card-custom .product-details {
    padding-top: 6px !important; /* Espaçamento uniforme no topo */
  }
  .produto-card-custom .status-text, 
  .produto-card-custom .product-details .status-text,
  .produto-card-custom .text-danger.status-text,
  .produto-card-custom div.status-text,
  .produto-card-custom span.status-text {
    font-size: 6px !important;
    padding: 4px 3px !important;
    min-height: 22px !important; /* Igualado ao price-display para manter cards do mesmo tamanho no mobile */
    line-height: 1 !important;
    margin: 0 !important;
    margin-top: 0 !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    height: auto !important;
    flex-grow: 1 !important; /* Ocupa o mesmo espaço que o price-display */
    white-space: nowrap !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
  }
  .produto-card-custom .price-display,
  .produto-card-custom div.price-display {
    padding: 4px 3px !important;
    margin: 0 !important;
    margin-top: 0 !important;
    font-size: 6px !important;
    min-height: 22px !important; /* Altura padronizada para mobile */
    flex-grow: 1 !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    line-height: 1 !important;
  }
  .price-display h4 {
    font-size: 6px !important; /* Padronizado para 6px */
    padding: 0 !important;
    margin: 0 !important;
    line-height: 1.2 !important;
    white-space: nowrap !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
  }
  .price-display h4 small {
    font-size: 6px !important; /* Texto 'Faça login para ver o preço' - Padronizado para 6px */
    padding: 0 !important;
    margin: 0 !important;
    white-space: nowrap !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
  }
  .price-display h4 b {
    font-size: 6px !important;
  }
  #buy-button-{
    width: 100% !important;
    scale: 1;
    margin-top: 0 !important;
    padding: 0 !important;
  }
  
  .btn-wrapper-adicionar {
    width: 100% !important;
    padding: 0 !important;
    margin: 0 !important;
    box-sizing: border-box !important;
  }
  
  .btn-adicionar-card {
    width: 100% !important;
    margin: 0 !important;
    padding: 0 !important;
    border-radius: 4px !important;
    min-height: unset !important;
    height: 22px !important;
    line-height: 1 !important;
  }

  .btn-adicionar-card small {
    font-size: 0.75rem !important;
  }
  .product-image{
    padding: 10px !important;
  }
  
  /* Estílo Botão Avise-me no Card (Mobile) */
  .btn-avise-me-card {
    border: 1px solid var(--mx3-style-primary, #00d9ff) !important;
    background: rgba(0, 217, 255, 0.1) !important;
    color: var(--mx3-style-primary, #00d9ff) !important;
    font-weight: 600 !important;
    padding: 0 !important;
    height: 22px !important;
    max-height: 22px !important;
    line-height: 1 !important;
    transition: all 0.3s ease !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    font-size: 0.72rem !important; /* Tamanho reduzido para mobile */
    border-radius: 4px !important; /* Padronizado para 4px */
    width: 100% !important;
    margin: 0 !important;
    min-height: 22px !important;
  }
  
  .btn-wrapper-avise-me .btn-avise-me-card {
    height: 22px !important;
    max-height: 22px !important;
    min-height: 22px !important;
  }
  
  .produto-card-custom .btn-avise-me-card {
    height: 22px !important;
    max-height: 22px !important;
    min-height: 22px !important;
  }
  
  .btn-avise-me-card:hover {
    background: rgba(0, 217, 255, 0.1) !important;
    color: #ffffff !important;
  }
  
  .btn-avise-me-card .btn-text-adicionar span {
    font-size: 6px !important;
  }
}

/* Estílo Botão Avise-me no Card (Desktop) */
.btn-avise-me-card {
  border: 1px solid var(--mx3-style-primary, #00d9ff) !important;
  background: rgba(0, 217, 255, 0.1) !important;
  color: var(--mx3-style-primary, #00d9ff) !important;
  font-weight: 600 !important;
  padding: 6px 0 !important;
  transition: all 0.3s ease !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  font-size: 0.85rem !important;
  border-radius: 6px !important;
  width: 100% !important;
  margin: 0 !important;
  min-height: 28px !important;
  height: auto !important;
  line-height: 1.2 !important;
}

.btn-avise-me-card:hover {
  background: rgba(0, 217, 255, 0.1) !important;
  color: #ffffff !important;
}




.cursor-pointer {
  cursor: pointer;
}
.buttons-product-card {
}
.call-to-action .product-showcase {
  background: transparent !important;
}
.call-to-action .product-showcase .buttons-product-card {
  display: flex;
  justify-content: center; /* opcional: centraliza horizontal */
  align-items: flex-end; /* joga a filha para baixo */
}

#img-produto-card-list {
  object-fit: contain !important;
  background: #afafaf08;
  border-radius: 0px !important;
}

@media (max-width: 768px) {
  #img-produto-card-list {
    object-fit: contain !important;
  }
}

.produto-card-custom {
  position: relative !important;
  background: #232323 !important;
  background-color: #232323 !important;
  border: 0.1px #afafaf30 solid !important;
  background: rgba(36, 36, 36, 0.8) !important;
  border-radius: 1rem !important;
  padding: 2.5rem 2rem;
  text-align: center !important;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1) !important;
  backdrop-filter: blur(10px) !important;
  display: flex !important;
  flex-direction: column !important;
  justify-content: space-between !important;
  min-height: 100% !important;
}

.produto-card-custom:hover {
  transform: translateY(-10px) !important;
  border-color: #00bfff50 !important;
  background: rgba(36, 36, 36, 0.95) !important;
  box-shadow: 0 20px 40px rgba(0, 191, 255, 0.3),
    0 0 60px rgba(0, 191, 255, 0.1) !important;
}

.product-image {
  flex-shrink: 0 !important;
}

#img-produto-card-list {
  height: 180px;
  width: 100% !important;
  margin-bottom: 10px !important;
}

/* Linha de ação rápida (coração da Lista de Desejos). Fica em sua própria
   linha, entre o título e o preço - nunca sobre a imagem do produto. A
   altura da linha é sempre reservada (evita o card "pular" quando o
   coração aparece/some), mas o botão em si só fica visível ao passar o
   mouse sobre o card (.produto-card-custom:hover). Em telas de toque, que
   não têm hover, ele permanece sempre visível - senão o recurso ficaria
   inacessível no celular. */
.card-quick-actions {
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 6;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  height: auto;
  padding: 0;
}

.wishlist-toggle-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  padding: 0;
  border: 1px solid var(--mx3-style-border, rgba(255, 255, 255, 0.18));
  border-radius: 50%;
  /* Usa as variáveis de tema já definidas em main.css/main-light.css (o
     site troca a folha de estilo inteira ao alternar claro/escuro, ver
     ThemeSwitcher.vue - por isso aqui não se usa uma classe de tema, e
     sim as mesmas variáveis que cada folha já define com o valor certo
     para o seu próprio tema). */
  background: color-mix(in srgb, var(--mx3-style-bg-card, #161b26), transparent 25%);
  color: var(--default-color, #ffffff);
  font-size: 0.85rem;
  line-height: 1;
  cursor: pointer;
  opacity: 0;
  visibility: hidden;
  transform: scale(0.85);
  transition: opacity 0.15s ease, transform 0.15s ease, background 0.15s ease, color 0.15s ease, border-color 0.15s ease;
}

/* Em desktop o coração só aparece enquanto o usuário passa o mouse sobre o card. */
@media (hover: hover) and (pointer: fine) {
  .produto-card-custom:hover .wishlist-toggle-btn,
  .produto-card-custom:focus-within .wishlist-toggle-btn {
    opacity: 1;
    visibility: visible;
    transform: scale(1);
  }
}

@media (max-width: 768px) {
  .wishlist-toggle-btn {
    opacity: 1;
    visibility: visible;
    transform: scale(1);
  }
  .card-quick-actions {
    top: 6px;
    right: 6px;
  }
  .wishlist-toggle-btn {
    width: 20px;
    height: 20px;
    font-size: 0.7rem;
  }
}

.wishlist-toggle-btn:hover {
  transform: scale(1.1);
  border-color: #ff4d6d;
  color: #ff4d6d;
}

.wishlist-toggle-btn.is-active {
  background: rgba(255, 77, 109, 0.15);
  border-color: #ff4d6d;
  color: #ff4d6d;
}

.wishlist-toggle-btn.is-active:hover {
  color: #ff1f45;
}

.product-details {
  flex-grow: 1 !important;
  display: flex !important;
  flex-direction: column !important;
  justify-content: flex-start !important;
  min-height: auto !important;
  padding: 0 !important;
  margin: 0 !important;
}

.product-title {
  padding: 8px 8px 0 8px !important;
  margin: 0 !important;
  font-size: 0.85rem !important;
  line-height: 1.3 !important;
  min-height: 100px !important;
  max-height: 100px !important;
  display: -webkit-box !important;
  -webkit-line-clamp: 10 !important;
  -webkit-box-orient: vertical !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  word-break: break-word !important;
}

.divider-line {
  border-top: 0.1px solid #ffffff50 !important;
  margin: 2px 8px 0 8px !important;
  height: 0 !important;
  width: calc(100% - 16px) !important;
}

/* DESKTOP: Status e Preço com altura padronizada de 40px */
@media (min-width: 769px) {
  .product-details .status-text {
    padding: 8px 8px !important;
    margin: 0 !important;
    font-size: 0.85rem !important;
    min-height: 40px !important;
    height: 40px !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    text-align: center !important;
    width: 100% !important;
    flex-grow: 0 !important;
    line-height: 1.4 !important;
  }

  .product-details .price-display {
    padding: 8px 8px !important;
    margin: 0 !important;
    flex-grow: 0 !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    min-height: 40px !important;
    height: 40px !important;
    line-height: 1.4 !important;
  }

  .price-display h4 {
    margin: 0 !important;
    padding: 0 !important;
    font-size: 0.85rem !important;
    line-height: 1.4 !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
  }

  .price-display h4 b {
    margin: 0 !important;
    padding: 0 !important;
    line-height: 1.4 !important;
  }

  .price-display h4 small {
    margin: 0 !important;
    padding: 0 !important;
    font-size: 0.85rem !important;
    line-height: 1.4 !important;
  }

  /* Garantir que o h4 dentro de price-display respeite a altura total de 40px */
  .product-details .price-display h4 {
    height: 100% !important;
    min-height: 40px !important;
    max-height: 40px !important;
  }

  /* Garantir que o status-text também respeite a altura total de 40px */
  .product-details .status-text {
    height: 40px !important;
    min-height: 40px !important;
    max-height: 40px !important;
  }
}

/* MOBILE: Status e Preço com altura padronizada de 22px e fonte 6px */
@media (max-width: 768px) {
  .product-details .status-text {
    padding: 4px 3px !important;
    margin: 0 !important;
    font-size: 6px !important;
    min-height: 22px !important;
    height: 22px !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    text-align: center !important;
    width: 100% !important;
    flex-grow: 0 !important;
    line-height: 1 !important;
  }

  .product-details .price-display {
    padding: 4px 3px !important;
    margin: 0 !important;
    flex-grow: 0 !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    min-height: 22px !important;
    height: 22px !important;
    line-height: 1 !important;
  }

  .price-display h4 {
    margin: 0 !important;
    padding: 0 !important;
    font-size: 6px !important;
    line-height: 1 !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
  }

  .price-display h4 b {
    margin: 0 !important;
    padding: 0 !important;
    line-height: 1 !important;
    font-size: 6px !important;
  }

  .price-display h4 small {
    margin: 0 !important;
    padding: 0 !important;
    font-size: 6px !important;
    line-height: 1 !important;
  }
}

.price-section {
  border-top: 0.1px solid #ffffff50 !important;
  padding: 8px 0 !important;
  margin: 0 !important;
}

/* Melhoria 3: Botão Adicionar alinhado com o fundo da imagem do produto */
.btn-container-adicionar {
  padding: 0 !important;
  width: 100% !important;
  overflow: visible !important;
  margin: 0 !important;
}

.btn-container-wrapper {
  width: 100% !important;
  padding: 0 8px 8px 8px !important;
  display: flex !important;
  justify-content: center !important;
  flex-shrink: 0 !important;
  margin-top: auto !important;
}

.btn-wrapper-adicionar {
  width: 100% !important;
  padding: 0 !important;
  box-sizing: border-box !important;
  margin: 0 !important;
}

.btn-adicionar-card {
  width: 100% !important;
  margin: 0 !important;
  padding: 6px 0 !important;
  height: auto !important;
  min-height: 28px !important;
  border-radius: 6px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}

.btn-adicionar-card .btn-text-adicionar {
  font-size: 0.85rem !important;
}

/* Desktop: Alinhar botao com moldura da imagem */
@media (min-width: 769px) {
  .btn-container-wrapper {
    width: calc(100% + 4rem) !important;
    margin: 0 -2rem 0 -2rem !important;
    padding: 8px 2rem 0 2rem !important;
    display: flex !important;
    justify-content: center !important;
  }

  .btn-wrapper-adicionar {
    width: 100% !important;
    padding: 0 !important;
  }

  .btn-adicionar-card {
    min-height: 28px !important;
    padding: 6px 0 !important;
    height: auto !important;
    line-height: 1.2 !important;
    border-radius: 6px !important;
  }
}

/* Mobile: Achatar botão e adicionar padding inferior para não vazar do card */
@media (max-width: 768px) {
  .btn-container-wrapper {
    padding: 4px 10px 6px 10px !important;
  }

  .btn-wrapper-adicionar {
    width: 100% !important;
    padding: 0 !important;
  }

  .btn-adicionar-card {
    min-height: unset !important;
    height: 22px !important;
    padding: 0 0 !important;
    line-height: 1 !important;
    border-radius: 4px !important;
    font-size: 0.75rem !important;
  }

  .btn-adicionar-card .btn-text-adicionar {
    font-size: 0.72rem !important;
    gap: 3px !important;
  }

  .btn-adicionar-card .btn-text-adicionar svg {
    width: 12px !important;
    height: 12px !important;
  }
}

/* Aviso "Faça login para ver o preço" no card: apenas indica que é
   clicável, sem alterar a aparência original (sem sublinhado). */
.mx3-login-price-link{cursor:pointer}
</style>
